// @flow
import is from './is'

const fastForEach = (subject, iterator) => {
  const { length } = subject
  for (let i = 0; i < length; i += 1) {
    iterator(subject[i], i)
  }
}

/**
 * Iterate over given subject and run given iterator function
 * for every found item. If given subject is not an array and
 * not undefined, then iterator will be executed with given subject.
 * That is why it called `maybe` - you could pass subject or an array
 * of subjects, both works the same.
 * @param  {any|Array<any>|void} subject
 * @param  {Function} iterator
 */
function maybeForEach<T>(
  subject: ?Array<T> | T,
  iterator: (item: T, index: number) => any
) {
  if (is.array(subject)) {
    fastForEach((subject: any), iterator)
  } else if (is.notUndef(subject)) {
    iterator((subject: any), 0)
  }
}

export default maybeForEach
